import { Chart, ChartDataPoint } from '@frontend/chart/types';

export interface TimeSeriesMockOptions {
    days?: number;
    scale?: number;
    seriesName?: string;
}

const buildDailyPoints = (days: number, scale: number): ChartDataPoint[] => {
    const today = new Date();

    return Array.from({ length: days }, (_, index) => {
        const date = new Date(today);
        // Use UTC to avoid timezone shifts when slicing the ISO string.
        date.setUTCDate(today.getUTCDate() - (days - 1 - index));

        return {
            label: date.toISOString().slice(0, 10),
            value: Math.round((18 + Math.sin(index / 2) * 12 + index * 1.5) * scale)
        };
    });
};

export const createSingleSeriesTimeSeriesMockData = (options?: TimeSeriesMockOptions): Chart => ({
    series: [
        {
            name: options?.seriesName ?? 'Transactions',
            data: buildDailyPoints(options?.days ?? 14, options?.scale ?? 1)
        }
    ]
});

export interface MonthlyTimeSeriesMockOptions {
    months?: number;
    scale?: number;
    series?: { name: string; scale?: number }[];
}

const buildMonthlyPoints = (months: number, scale: number): ChartDataPoint[] => {
    const today = new Date();
    today.setUTCDate(1);
    today.setUTCHours(0, 0, 0, 0);

    return Array.from({ length: months }, (_, index) => {
        const date = new Date(today);
        date.setUTCMonth(today.getUTCMonth() - (months - 1 - index));

        return {
            label: date.toISOString().slice(0, 10),
            value: Math.max(0, Math.round((8 + Math.sin(index / 2) * 6 + (index % 4) * 2) * scale))
        };
    });
};

export const createMonthlyTimeSeriesMockData = (options?: MonthlyTimeSeriesMockOptions): Chart => {
    const months = options?.months ?? 13;
    const series = options?.series ?? [{ name: 'Transactions' }];

    return {
        series: series.map((item) => ({
            name: item.name,
            data: buildMonthlyPoints(months, (item.scale ?? 1) * (options?.scale ?? 1))
        }))
    };
};

export const createStackedTimeSeriesMockData = (options?: TimeSeriesMockOptions): Chart => {
    const points = buildDailyPoints(options?.days ?? 14, options?.scale ?? 1);

    return {
        series: [
            {
                name: 'Drop-off',
                data: points.map((point, index) => ({
                    label: point.label,
                    value: Math.round(point.value * (0.45 + (index % 3) * 0.05))
                }))
            },
            {
                name: 'Pick-up',
                data: points.map((point, index) => ({
                    label: point.label,
                    value: Math.round(point.value * (0.4 + ((index + 1) % 3) * 0.05))
                }))
            }
        ]
    };
};
